import { ElementRef, EventEmitter, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { AppConstants } from '../AppConstants';
const ɵ0 = (container) => {
    return container;
};
export class FormInputComponent {
    constructor(el, cc) {
        this.el = el;
        this.cc = cc;
        this.focus = new EventEmitter();
    }
    ngOnInit() {
        if (this.cc.control && this.cc.control instanceof FormGroup) {
            this.valueChangeSubscription = this.cc.control.controls[this.field].valueChanges.subscribe((val) => {
                this.resolvedInputNGClass = {
                    'is-valid': this.isValid,
                    'is-invalid': this.isInvalid,
                    'has-value': !!val && val.match(AppConstants.NOT_NULL_PATTERN),
                    'form-control-lg': this.size === 'lg',
                    'form-control-sm': this.size === 'sm',
                };
            });
        }
        else {
            throw new Error('Only FormGroup wrapped controls are supported');
        }
    }
    ngOnDestroy() {
        if (this.valueChangeSubscription) {
            this.valueChangeSubscription.unsubscribe();
            this.valueChangeSubscription = undefined;
        }
    }
    ngOnChanges() {
        if (this.type === undefined) {
            this.type = 'text';
        }
        if (this.placeholder === undefined) {
            this.placeholder = '';
        }
        if (this.autocomplete === undefined) {
            this.autocomplete = '';
        }
        if (this.class === undefined) {
            this.hostClass = FormInputComponent.WRAPPER_CLASS;
        }
        else {
            this.hostClass = FormInputComponent.WRAPPER_CLASS + ' ' + this.class;
        }
        this.resolvedInputNGClass = {
            'is-valid': this.isValid,
            'is-invalid': this.isInvalid,
            'has-value': (this.cc.control && this.cc.control instanceof FormGroup ?
                !!this.cc.control.controls[this.field].value && this.cc.control.controls[this.field].value.match(AppConstants.NOT_NULL_PATTERN) :
                false),
            'form-control-lg': this.size === 'lg',
            'form-control-sm': this.size === 'sm',
        };
        this.hostAutocomplete = null;
        this.hostField = null;
        this.hostLabel = null;
        this.hostType = null;
        this.hostSize = null;
        this.hostPlaceholder = null;
    }
    // noinspection JSMethodCanBeStatic
    wrapperClass() {
        return FormInputComponent.WRAPPER_CLASS;
    }
    // noinspection JSMethodCanBeStatic
    labelClass() {
        if (this.prepend || this.append) {
            return FormInputComponent.LABEL_CLASS + ' on-top';
        }
        else {
            return FormInputComponent.LABEL_CLASS;
        }
    }
    // noinspection JSMethodCanBeStatic
    controlWrapperClass() {
        return FormInputComponent.CONTROL_WRAPPER_CLASS;
    }
    onInputFocus() {
        this.focus.emit();
    }
}
FormInputComponent.WRAPPER_CLASS = 'form-group';
FormInputComponent.LABEL_CLASS = 'placeholder-label';
FormInputComponent.CONTROL_WRAPPER_CLASS = '';
export { ɵ0 };
